export const periods = ['Q1', 'Q2', 'Q3', 'Q4']
